import './style.modules.scss'

import React from 'react'
import xss, { FilterXSS, whiteList } from 'xss'

import { Link } from '../../types/Link.type'
import { decorateLastWord } from './decorateLastWord'

export type RelatedInfoLinkProps = {
  link: Link
  testId?: string
}

const customXssFilter = new FilterXSS({
  whiteList: {
    ...whiteList,
    span: ['class', 'aria-hidden']
  }
})

export const RelatedInfoLink = (props: RelatedInfoLinkProps) => {
  const { link, testId } = props

  const arrowIcon =
    '<span class="adel-material-symbols RelatedLinks--arrow" aria-hidden="true">arrow_forward</span>'

  const decoratedName = decorateLastWord(link.name, {
    wrapperClassName: 'RelatedLinks-noWrap',
    afterContent: arrowIcon
  })

  return (
    <li data-testid={testId ? `${testId}-related-links` : undefined}>
      <a
        href={xss(link.url)}
        target={link.target}
        data-analytics={link.analyticsName}
        data-testid={testId ? `${testId}-link` : undefined}
        dangerouslySetInnerHTML={{
          __html: customXssFilter.process(decoratedName)
        }}
      />
    </li>
  )
}
